import React from 'react';
export const Nav01DataSource =(t) =>({
  wrapper: { className: 'header0 home-page-wrapper' },
  page: { className: 'home-page' },
  logo: {
    className: 'header0-logo',
    children: 'https://www.bmr-oe.com/static/images/logo15.png',
  },
  Menu: {
    className: 'header0-menu',
    children: [
      {
        name: 'item~mf1voqnpqzd',
        className: 'header0-item',
        children: {
          href: '/#',
          children: [
            {
              children: (
                <span>
                  <span>
                    <span>
                      <p>{t('wfrIzul7TVXcOPS4IGVNY')}</p>
                    </span>
                  </span>
                </span>
              ),
              name: 'text',
            },
          ],
        },
      },
      {
        name: 'item0',
        className: 'header0-item',
        children: {
          href: '#',
          children: [
            {
              children: (
                <span>
                  <span>
                    <span>
                      <span>
                        <span>
                          <p>{t('WDmydAkJBmPGVaBgI0EzC')}</p>
                        </span>
                      </span>
                    </span>
                  </span>
                </span>
              ),
              name: 'text',
            },
          ],
        },
        subItem: [
          {
            name: 'sub0',
            className: 'item-sub',
            children: {
              className: 'item-sub-item',
              children: [
                {
                  name: 'image0',
                  className: 'item-image m9l2x14xpk-editor_css',
                  children:
                    'https://www.bmr-oe.com/static/images/ico-v2/强激光78.ico',
                },
                {
                  name: 'title',
                  className: 'item-title m8wyzpxxeu-editor_css',
                  children: (
                    <span>
                      <span>
                        <p>{t('s-25ubzd1hkcHHg7DqWjS')}</p>
                      </span>
                    </span>
                  ),
                },
              ],
              href: '/#/second1',
            },
          },
          {
            name: 'sub1',
            className: 'item-sub',
            children: {
              className: 'item-sub-item',
              children: [
                {
                  name: 'image0',
                  className: 'item-image m8x0fu3h09i-editor_css',
                  children:
                    'https://www.bmr-oe.com/static/images/ico-v2/通用双轴50.ico',
                },
                {
                  name: 'title',
                  className: 'item-title m8x0c7zgutn-editor_css',
                  children: (
                    <span>
                      <span>
                        <span>
                          <p>{t('vneBJxXe7KK8m15yEKJTy')}</p>
                        </span>
                      </span>
                    </span>
                  ),
                },
              ],
              href: '/#/second2',
            },
          },
          {
            name: 'sub~m8x12rhcd3r',
            className: 'item-sub',
            children: {
              className: 'item-sub-item',
              children: [
                {
                  name: 'image0',
                  className: 'item-image m8x0fu3h09i-editor_css',
                  children:
                    'https://www.bmr-oe.com/static/images/ico-v2/单轴50.ico',
                },
                {
                  name: 'title',
                  className: 'item-title m8x0c7zgutn-editor_css',
                  children: (
                    <span>
                      <span>
                        <span>
                          <span>
                            <p>{t('3oqA8YREYTmLNkWiZQh6T')}</p>
                          </span>
                        </span>
                      </span>
                    </span>
                  ),
                },
              ],
              href: '/#/second3',
            },
          },
          {
            name: 'sub~m8x12unqvh',
            className: 'item-sub',
            children: {
              className: 'item-sub-item',
              children: [
                {
                  name: 'image0',
                  className: 'item-image m8x0fu3h09i-editor_css',
                  children:
                    'https://www.bmr-oe.com/static/images/ico-v2/摆扫镜30.ico',
                },
                {
                  name: 'title',
                  className: 'item-title m8x0c7zgutn-editor_css',
                  children: (
                    <span>
                      <span>
                        <span>
                          <span>
                            <span>
                              <span>
                                <span>
                                  <span>
                                    <p>{t('co9BzKjWxNbm85qTS3wb7')}</p>
                                  </span>
                                </span>
                              </span>
                            </span>
                          </span>
                        </span>
                      </span>
                    </span>
                  ),
                },
              ],
              href: '/#/second4',
            },
          },
          {
            name: 'sub~m8x12vr6qz',
            className: 'item-sub',
            children: {
              className: 'item-sub-item',
              children: [
                {
                  name: 'image0',
                  className: 'item-image m8x0fu3h09i-editor_css',
                  children:
                    'https://www.bmr-oe.com/static/images/ico-v2/振镜6240.ico',
                },
                {
                  name: 'title',
                  className: 'item-title m8x0c7zgutn-editor_css',
                  children: (
                    <span>
                      <span>
                        <span>
                          <span>
                            <span>
                              <span>
                                <span>
                                  <p>{t('uUP0AdGrJz1f9fbcHxwDq')}</p>
                                </span>
                              </span>
                            </span>
                          </span>
                        </span>
                      </span>
                    </span>
                  ),
                },
              ],
              href: '/#/second5',
            },
          },
          {
            name: 'sub~m8x12wndado',
            className: 'item-sub',
            children: {
              className: 'item-sub-item',
              children: [
                {
                  name: 'image0',
                  className: 'item-image m8x0fu3h09i-editor_css',
                  children:
                    'https://www.bmr-oe.com/static/images/ico-v2/电调镜78.ico',
                },
                {
                  name: 'title',
                  className: 'item-title m8x0c7zgutn-editor_css',
                  children: (
                    <span>
                      <span>
                        <span>
                          <span>
                            <p>{t('j-StTkPrqXmQP1G8DFPo9')}</p>
                          </span>
                        </span>
                      </span>
                    </span>
                  ),
                },
              ],
              href: '/#/second6',
            },
          },
          {
            name: 'sub~m8x12xgznka',
            className: 'item-sub',
            children: {
              className: 'item-sub-item',
              children: [
                {
                  name: 'image0',
                  className: 'item-image m8x0fu3h09i-editor_css',
                  children:
                    'https://www.bmr-oe.com/static/images/ico-v2/电动镜127.ico',
                },
                {
                  name: 'title',
                  className: 'item-title m8x0c7zgutn-editor_css',
                  children: (
                    <span>
                      <span>
                        <span>
                          <span>
                            <span>
                              <p>{t('qEBn1hSbOBkE4KokpebzF')}</p>
                            </span>
                          </span>
                        </span>
                      </span>
                    </span>
                  ),
                },
              ],
              href: '/#/second7',
            },
          },
          {
            name: 'sub~m8x12yp8s7o',
            className: 'item-sub m976jn6jedn-editor_css',
            children: {
              className: 'item-sub-item',
              children: [
                {
                  name: 'image0',
                  className: 'item-image m8x0fu3h09i-editor_css',
                  children:
                    'https://www.bmr-oe.com/static/images/ico-v2/激光通信20.ico',
                },
                {
                  name: 'title',
                  className: 'item-title m8x0c7zgutn-editor_css',
                  children: (
                    <span>
                      <span>
                        <span>
                          <span>
                            <span>
                              <span>
                                <span>
                                  <span>
                                    <span>
                                      <span>
                                        <span>
                                          <span>
                                            <p>{t('MHizWJou2jxtukndyUMfB')}</p>
                                          </span>
                                        </span>
                                      </span>
                                    </span>
                                  </span>
                                </span>
                              </span>
                            </span>
                          </span>
                        </span>
                      </span>
                    </span>
                  ),
                },
              ],
              href: '/#/second8',
            },
          },
          {
            name: 'sub~m9l31knlmcb',
            className: 'item-sub m976jn6jedn-editor_css',
            children: {
              className: 'item-sub-item',
              children: [
                {
                  name: 'image0',
                  className: 'item-image m8x0fu3h09i-editor_css',
                  children:
                    'https://www.bmr-oe.com/static/images/ico-v2/永磁同步75.ico',
                },
                {
                  name: 'title',
                  className: 'item-title m8x0c7zgutn-editor_css',
                  children: (
                    <span>
                      <span>
                        <span>
                          <span>
                            <span>
                              <span>
                                <span>
                                  <span>
                                    <span>
                                      <span>
                                        <span>
                                          <p>{t('3SUeEoTzGKngpsd312TqB')}</p>
                                        </span>
                                      </span>
                                    </span>
                                  </span>
                                </span>
                              </span>
                            </span>
                          </span>
                        </span>
                      </span>
                    </span>
                  ),
                },
              ],
              href: '/#/second9',
            },
          },
        ],
      },
      {
        name: 'item1',
        className: 'header0-item',
        children: {
          href: '/#/fourth',
          children: [
            {
              children: (
                <span>
                  <span>
                    <span>
                      <span>
                        <p>{t('0xC3aMsBf7aQg6HgSj6x9')}</p>
                      </span>
                    </span>
                  </span>
                </span>
              ),
              name: 'text',
            },
          ],
        },
      },
      {
        name: 'item2',
        className: 'header0-item',
        children: {
          href: '/#/tenth',
          children: [
            {
              children: (
                <span>
                  <span>
                    <span>
                      <span>
                        <span>
                          <p>{t('W7x_qj28IIet1z9qfRRag')}</p>
                        </span>
                      </span>
                    </span>
                  </span>
                </span>
              ),
              name: 'text',
            },
          ],
        },
      },
      {
        name: 'item3',
        className: 'header0-item',
        children: {
          href: '/#/fifth',
          children: [
            {
              children: (
                <span>
                  <span>
                    <span>
                      <p>{t('L-hgsDxHlVL89rjl90PiA')}</p>
                    </span>
                  </span>
                </span>
              ),
              name: 'text',
            },
          ],
        },
      },
      {
        name: 'item~m98oygx0zqi',
        className: 'header0-item',
        children: {
          href: '/#/sixth',
          children: [
            {
              children: (
                <span>
                  <span>
                    <p>{t('fVP4pxCKZvTFgCvngOt21')}</p>
                  </span>
                </span>
              ),
              name: 'text',
            },
          ],
        },
      },
    ],
  },
  mobileMenu: { className: 'header0-mobile-menu' },
});
export const Banner10DataSource = (t) =>({
  wrapper: { className: 'banner1 m8wmyqt62ma-editor_css' },
  BannerAnim: {
    children: [
      {
        name: 'elem0',
        BannerElement: { className: 'banner-user-elem' },
        textWrapper: { className: 'banner1-text-wrapper' },
        bg: { className: 'bg bg0 m8wmxqt4hsf-editor_css' },
        title: { className: 'banner1-title', children: '' },
        content: {
          className: 'banner1-content m8wt5yzvohu-editor_css',
          children: (
            <span>
              <span>
                <span>
                  <span>
                    <span>
                      <span>
                        <span>
                          <span>
                            <span>
                              <blockquote>
                                {t('K-HbIYm2dzEkukVUPet4h')}
                              </blockquote>
                            </span>
                          </span>
                        </span>
                      </span>
                    </span>
                  </span>
                </span>
              </span>
            </span>
          ),
        },
        button: {
          className: 'banner1-button m8wtjvr1hjk-editor_css',
          children: (
            <span>
              <span>
                <p>
                  <br />
                </p>
              </span>
            </span>
          ),
        },
      },
      {
        name: 'elem2',
        BannerElement: { className: 'banner-user-elem' },
        textWrapper: { className: 'banner1-text-wrapper' },
        bg: { className: 'bg bg1 m96u0zciy-editor_css' },
        title: { className: 'banner1-title', children: '' },
        content: {
          className: 'banner1-content m96ve128cj-editor_css',
          children: (
            <span>
              <span>
                <span>
                  <span>
                    <span>
                      <p>{t('54sAAGAabGQiSODssIt0f')}</p>
                      <p>{t('xW__I0EfFuI3GUS7c7rht')}</p>
                    </span>
                  </span>
                </span>
              </span>
            </span>
          ),
        },
        button: {
          className: 'banner1-button m96u6oixptm-editor_css',
          children: (
            <span>
              <p>
                <br />
              </p>
            </span>
          ),
        },
      },
    ],
    autoPlay: true,
    type: ['across'],
    autoPlaySpeed: 5000,
  },
});
export const Feature40DataSource =(t)=>( {
  wrapper: {
    className: 'home-page-wrapper content6-wrapper mr5xtzxga4t-editor_css',
  },
  OverPack: { className: 'home-page content6 mr4d6kzfdn-editor_css' },
  textWrapper: {
    className: 'content6-text mr4h30f0tii-editor_css',
    xs: 24,
    md: 10,
  },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: (
          <span>
            <p>
              <a href="/#/seventh">{t('O4R7SNCE9UWWyYoklOmzr')}</a>
              </p>
          </span>
        ),
        className: 'title-h1 mr4bnhz0pb9-editor_css',
      },
      {
        name: 'content',
        className: 'title-content mr4bnh4vwvd-editor_css',
        children: (
          <span>
            <span>
              <span>
                <h1>
                &nbsp; &nbsp; &nbsp; &nbsp;
                  {t('xk84nRBR5ECFEMLXUvKXP')}
                </h1>
                <p>
                &nbsp; &nbsp; &nbsp; &nbsp;
                  {t('a5YAI2AN6amuc034UDkCv')}
                </p>
              </span>
            </span>
          </span>
        ),
      },
      {
        name: 'content~mraefgz77xe',
        className: 'mraefi4bo1p-editor_css',
        children: (
          <span>
            <span>
              <p>
                <a href="/#/seventh">MORE&gt;&gt;</a>
                <br />
              </p>
            </span>
          </span>
        ),
      },
    ],
  },
  img: {
    children: 'https://www.bmr-oe.com/static/images/公司大楼.jpg',
    className: 'content6-img mr4dch1j7xq-editor_css',
    xs: 24,
    md: 14,
  },
/*   block: {
    children: [
      {
        name: 'block0',
        img: {
          children: '',
          className: 'content6-icon mr5xtb2kn6d-editor_css',
        },
        title: {
          className: 'content6-title',
          children: (
            <span>
              <p>
                <br />
              </p>
            </span>
          ),
        },
        content: {
          className: 'content6-content',
          children: (
            <span>
              <br />
            </span>
          ),
        },
      },
      {
        name: 'block1',
        img: { className: 'content6-icon', children: '' },
        title: {
          className: 'content6-title',
          children: (
            <span>
              <br />
            </span>
          ),
        },
        content: {
          className: 'content6-content',
          children: (
            <span>
              <br />
            </span>
          ),
        },
      },
      {
        name: 'block2',
        img: { className: 'content6-icon', children: '' },
        title: {
          className: 'content6-title',
          children: (
            <span>
              <br />
            </span>
          ),
        },
        content: {
          className: 'content6-content',
          children: (
            <span>
              <br />
            </span>
          ),
        },
      },
    ],
  }, */
  block: {
  children: []
},
});
export const Content50DataSource = (t) =>({
  wrapper: {
    className: 'home-page-wrapper content5-wrapper m9b6is6ckqe-editor_css',
  },
  page: { className: 'home-page content5 m8wu3dg2hp-editor_css' },
  OverPack: { playScale: 0.3, className: '' },
  titleWrapper: {
    className: 'title-wrapper m98nhigd9l-editor_css',
    children: [
      {
        name: 'title',
        children: (
          <span>
            <span>
              <span>
                <span>
                  <p>
                    <a href="/#/second">{t('T8eiLvV1WuW8z9XPvyEln')}</a>
                  </p>
                </span>
              </span>
            </span>
          </span>
        ),
        className: 'title-h1 m8wthhn90i-editor_css',
      },
      {
        name: 'content~m9la0vn6k3m',
        className: 'm9la1ro4y0t-editor_css',
        children: (
          <span>
            <span>
              <p>
                <a href="/#/second">MORE&gt;&gt;</a>
                <br />
              </p>
            </span>
          </span>
        ),
      },
    ],
  },
  block: {
    className: 'content5-img-wrapper',
    gutter: 24,
    children: [
      {
        name: 'block0',
        className: 'block',
        md: 6,
        xs: 24,
        children: {
          wrapper: {
            className: 'content5-block-content',
            href: '/#/second1',
          },
          img: {
            children:
              'https://www.bmr-oe.com/static/images/bg/强激光78.png',
            className: 'm8nuclf1po8-editor_css',
          },
          content: {
            children: (
              <span>
                <span>
                  <span>
                    <span>
                      <span>
                        <span>
                          <span>
                            <span>
                              <span>
                                <h2>{t('Jc5CFu-PlHGyBWwS8naQ0')}</h2>
                              </span>
                            </span>
                          </span>
                        </span>
                      </span>
                    </span>
                  </span>
                </span>
              </span>
            ),
          },
        },
      },
      {
        name: 'block1',
        className: 'block',
        md: 6,
        xs: 24,
        children: {
          wrapper: {
            className: 'content5-block-content',
            href: '/#/second2',
          },
          img: {
            children:
              'https://www.bmr-oe.com/static/images/bg/通用双轴50.png',
            className: 'm8nug7io5cp-editor_css',
          },
          content: {
            children: (
              <span>
                <span>
                  <span>
                    <span>
                      <span>
                        <span>
                          <span>
                            <span>
                              <h2>{t('PpNP6lvI1kBgqAKcWH_VZ')}</h2>
                            </span>
                          </span>
                        </span>
                      </span>
                    </span>
                  </span>
                </span>
              </span>
            ),
          },
        },
      },
      {
        name: 'block2',
        className: 'block',
        md: 6,
        xs: 24,
        children: {
          wrapper: {
            className: 'content5-block-content',
            href: '/#/second3',
          },
          img: {
            children:
              'https://www.bmr-oe.com/static/images/bg/单轴50.png',
            className: 'm8nuhswaxb6-editor_css',
          },
          content: {
            children: (
              <span>
                <span>
                  <span>
                    <span>
                      <span>
                        <h2>{t('w7V5hET6mHstdygy2DEj-')}</h2>
                      </span>
                    </span>
                  </span>
                </span>
              </span>
            ),
          },
        },
      },
      {
        name: 'block3',
        className: 'block',
        md: 6,
        xs: 24,
        children: {
          wrapper: {
            className: 'content5-block-content',
            href: '/#/second4',
          },
          img: {
            children:
              'https://www.bmr-oe.com/static/images/bg/摆扫镜30.png',
            className: 'm8nuhvfo7sn-editor_css',
          },
          content: {
            children: (
              <span>
                <span>
                  <h2>{t('_ODx9tXPMSiDDwA5CV6cI')}</h2>
                </span>
              </span>
            ),
          },
        },
      },
      {
        name: 'block4',
        className: 'block',
        md: 6,
        xs: 24,
        children: {
          wrapper: {
            className: 'content5-block-content',
            href: '/#/second5',
          },
          img: {
            children:
              'https://www.bmr-oe.com/static/images/bg/振镜6240.png',
            className: 'm8nuhybgks-editor_css',
          },
          content: {
            children: (
              <span>
                <span>
                  <span>
                    <h2>{t('cVOIQvZHwyyQdYfmNMzN-')}</h2>
                  </span>
                </span>
              </span>
            ),
          },
        },
      },
      {
        name: 'block5',
        className: 'block',
        md: 6,
        xs: 24,
        children: {
          wrapper: {
            className: 'content5-block-content',
            href: '/#/second6',
          },
          img: {
            children:
              'https://www.bmr-oe.com/static/images/bg/电调镜78.png',
            className: 'm8nui14jpcu-editor_css',
          },
          content: {
            children: (
              <span>
                <span>
                  <h2>{t('L0SFYY82v0RlVe4I9q84s')}</h2>
                </span>
              </span>
            ),
          },
        },
      },
      {
        name: 'block6',
        className: 'block',
        md: 6,
        xs: 24,
        children: {
          wrapper: {
            className: 'content5-block-content',
            href: '/#/second7',
          },
          img: {
            children:
              'https://www.bmr-oe.com/static/images/bg/电动镜127.png',
            className: 'm8nui33kwie-editor_css',
          },
          content: {
            children: (
              <span>
                <span>
                  <span>
                    <span>
                      <h2>{t('9A7J9ngkTS3d6FNh4EebD')}</h2>
                    </span>
                  </span>
                </span>
              </span>
            ),
          },
        },
      },
      {
        name: 'block7',
        className: 'block',
        md: 6,
        xs: 24,
        children: {
          wrapper: {
            className: 'content5-block-content',
            href: '/#/second8',
          },
          img: {
            children:
              'https://www.bmr-oe.com/static/images/bg/激光通信20.png',
            className: 'm8nui4umf56-editor_css',
          },
          content: {
            children: (
              <span>
                <span>
                  <span>
                    <h2>{t('b3upChrgAcnR66_FlZgNb')}</h2>
                  </span>
                </span>
              </span>
            ),
          },
        },
      },
    ],
  },
});
export const Content51DataSource = (t) =>({
  wrapper: {
    className: 'home-page-wrapper content5-wrapper m9b6kozkqdj-editor_css',
  },
  page: { className: 'home-page content5' },
  OverPack: { playScale: 0.3, className: '' },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: (
          <span>
            <span>
              <span>
                <span>
                  <span>
                    <p>
                      <a href="/#/fourth">{t('3rIW7nRo7XXIWLJcPDH1h')}</a>
                    </p>
                  </span>
                </span>
              </span>
            </span>
          </span>
        ),
        className: 'title-h1',
      },
      {
        name: 'content',
        className: 'title-content m8fsbn35n98-editor_css',
        children: (
          <span>
            <span>
              <span>
                <span>
                  <span>
                    <span>
                      <p>
                        {t('oCMc2dvBhoxyPRVpq5C4w')}
                      </p>
                    </span>
                  </span>
                </span>
              </span>
            </span>
          </span>
        ),
      },
      {
        name: 'content~m9l9qdj29f7',
        className: 'm9l9qgmc24-editor_css',
        children: (
          <span>
            <span>
              <span>
                <span>
                  <p>
                    <a href="/#/fourth">MORE&gt;&gt;</a>
                  </p>
                </span>
              </span>
            </span>
          </span>
        ),
      },
    ],
  },
  block: {
    className: 'content5-img-wrapper',
    gutter: 16,
    children: [
      {
        name: 'block0',
        className: 'block',
        md: 6,
        xs: 24,
        children: {
          wrapper: {
            className: 'content5-block-content',
            href: '/#/fourth1',
          },
          img: {
            children:
              'https://www.bmr-oe.com/static/images/now/单轴78.png',
            className: 'm9l6ps0ogw-editor_css',
          },
          content: {
            children: (
              <span>
                <span>
                  <span>
                    <span>
                      <span>
                        <span>
                          <p>BMR8115-78</p>
                        </span>
                      </span>
                    </span>
                  </span>
                </span>
              </span>
            ),
            className: 'm9l8js3ecgd-editor_css',
          },
        },
      },
      {
        name: 'block1',
        className: 'block',
        md: 6,
        xs: 24,
        children: {
          wrapper: {
            className: 'content5-block-content',
            href: '/#/fourth2',
          },
          img: {
            children:
              'https://www.bmr-oe.com/static/images/now/单轴118.png',
            className: 'm9l6t3n4co9-editor_css',
          },
          content: {
            children: (
              <span>
                <span>
                  <span>
                    <span>
                      <span>
                        <p>BMR8115-100</p>
                      </span>
                    </span>
                  </span>
                </span>
              </span>
            ),
            className: 'm9l9fqmm1g7-editor_css',
          },
        },
      },
      {
        name: 'block2',
        className: 'block',
        md: 6,
        xs: 24,
        children: {
          wrapper: {
            className: 'content5-block-content',
            href: '/#/fourth3',
          },
          img: {
            children:
              'https://www.bmr-oe.com/static/images/now/单轴127.png',
            className: 'm9l6tcubnea-editor_css',
          },
          content: {
            children: (
              <span>
                <p>BMR8115-127</p>
              </span>
            ),
            className: 'm9l9gzxc9r8-editor_css',
          },
        },
      },
      {
        name: 'block3',
        className: 'block',
        md: 6,
        xs: 24,
        children: {
          wrapper: {
            className: 'content5-block-content',
            href: '/#/fourth4',
          },
          img: {
            children:
              'https://www.bmr-oe.com/static/images/now/单轴118未镀膜.png',
            className: 'm9l6tneqla-editor_css',
          },
          content: {
            children: (
              <span>
                <span>
                  <p>BMR8115-100N</p>
                </span>
              </span>
            ),
            className: 'm9l9if23ida-editor_css',
          },
        },
      },
      {
        name: 'block4',
        className: 'block',
        md: 6,
        xs: 24,
        children: {
          wrapper: {
            className: 'content5-block-content',
            href: '/#/fourth5',
          },
          img: {
            children:
              'https://www.bmr-oe.com/static/images/now/6220.png',
            className: 'm9l6u8jux2-editor_css',
          },
          content: {
            children: (
              <span>
                <span>
                  <p>BMR6220-10</p>
                </span>
              </span>
            ),
            className: 'm9l9j1u7pxe-editor_css',
          },
        },
      },
      {
        name: 'block5',
        className: 'block',
        md: 6,
        xs: 24,
        children: {
          wrapper: {
            className: 'content5-block-content',
            href: '/#/fourth6',
          },
          img: {
            children:
              'https://www.bmr-oe.com/static/images/now/6231.png',
            className: 'm9l6um0qj3-editor_css',
          },
          content: {
            children: (
              <span>
                <p>BMR6231-15</p>
              </span>
            ),
            className: 'm9l9jgd46zk-editor_css',
          },
        },
      },
      {
        name: 'block6',
        className: 'block',
        md: 6,
        xs: 24,
        children: {
          wrapper: {
            className: 'content5-block-content',
            href: '/#/fourth7',
          },
          img: {
            children:
              'https://www.bmr-oe.com/static/images/now/6240.png',
            className: 'm9l6v0hoai-editor_css',
          },
          content: {
            children: (
              <span>
                <p>BMR6240-30</p>
              </span>
            ),
            className: 'm9l9k0ti4a-editor_css',
          },
        },
      },
      {
        name: 'block7',
        className: 'block',
        md: 6,
        xs: 24,
        children: {
          wrapper: {
            className: 'content5-block-content',
            href: '/#/fourth8',
          },
          img: {
            children:
              'https://www.bmr-oe.com/static/images/now/7530.png',
            className: 'm9l6u3p56xn-editor_css',
          },
          content: {
            children: (
              <span>
                <p>BMR7530-30</p>
              </span>
            ),
            className: 'm9l9kocozvl-editor_css',
          },
        },
      },
    ],
  },
});
export const Feature00DataSource = (t) =>({
  wrapper: {
    className: 'home-page-wrapper content0-wrapper m9b69tudv1k-editor_css',
  },
  page: { className: 'home-page content0 m9b67r7orq-editor_css' },
  OverPack: { playScale: 0.3, className: '' },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: (
          <span>
            <span>
              <p>
                <a href="/#/tenth">{t('TwrN59rEb8Uoaaw0udKjv')}</a>
              </p>
            </span>
          </span>
        ),
      },
    ],
  },
  childWrapper: {
    className: 'content0-block-wrapper',
    children: [
      {
        name: 'block0',
        className: 'content0-block metb1wpt90n-editor_css',
        md: 8,
        xs: 24,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon m8fp8cpkuw6-editor_css',
              children:
                'https://www.bmr-oe.com/static/images/激光焊接2.jpg',
            },
            {
              name: 'title',
              className: 'content0-block-title m9b6cb1xoqp-editor_css',
              children: (
                <span>
                  <p>{t('LlCucDlsKh5KmISBeAk27')}</p>
                </span>
              ),
            },
            {
              name: 'content',
              children: (
                <span>
                  <p>{t('Q8F_K0zK55mC65cFUFrSE')}</p>
                </span>
              ),
              className: 'm8fpcqfx7sc-editor_css',
            },
          ],
        },
      },
      {
        name: 'block1',
        className: 'content0-block metb136hzjk-editor_css',
        md: 8,
        xs: 24,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon m8fqiib0uyp-editor_css',
              children:
                'https://www.bmr-oe.com/static/images/激光通信2.jpg',
            },
            {
              name: 'title',
              className: 'content0-block-title m9b6d713v-editor_css',
              children: (
                <span>
                  <p>{t('CUy4ywI2NKq4xhA7Wrkkd')}</p>
                </span>
              ),
            },
            {
              name: 'content',
              children: (
                <span>
                  <p>{t('sfrja_AEiI9313ywJc2hk')}</p>
                </span>
              ),
              className: 'm8fpcxz6wjc-editor_css',
            },
          ],
        },
      },
      {
        name: 'block2',
        className: 'content0-block metb0truafl-editor_css',
        md: 8,
        xs: 24,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon m8fpzm97v9s-editor_css',
              children:
                'https://www.bmr-oe.com/static/images/红外周视2.jpg',
            },
            {
              name: 'title',
              className: 'content0-block-title m9b6ezdy2m-editor_css',
              children: (
                <span>
                  <p>{t('5Hmv1DfyyN8UogxrLS3FQ')}</p>
                </span>
              ),
            },
            {
              name: 'content',
              children: (
                <span>
                  <p>{t('NR7UOlyn7GzFCgFtUCxIp')}</p>
                </span>
              ),
              className: 'm8fpd2gdl9e-editor_css',
            },
          ],
        },
      },
    ],
  },
});
export const Content30DataSource = (t) =>({
  wrapper: { className: 'home-page-wrapper content3-wrapper' },
  page: { className: 'home-page content3' },
  OverPack: { playScale: 0.3 },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: (
          <span>
            <span>
              <span>
                <span>
                  <p>
                    <a href="/#/fifth">{t('qHJsJaXesgSC6Pf_jnMZx')}</a>
                  </p>
                </span>
              </span>
            </span>
          </span>
        ),
        className: 'title-h1',
      },
      {
        name: 'more',
        className: 'm9l9qgmc24-editor_css', // 复用现货商城的样式
        children: (
          <span>
            <span>
              <span>
                <span>
                  <p><a href="/#/fifth">MORE&gt;&gt;</a></p>
                </span>
              </span>
            </span>
          </span>
        ),
      },
    ],
  },
  block: {
    className: 'content3-block-wrapper',
    children: [
            {
        name: 'block2',
        className: 'content3-block',
        md: 8,
        xs: 24,
        children: {
          icon: {
            className: 'content3-icon',
            children:
              'https://zos.alipayobjects.com/rmsportal/xMSBjgxBhKfyMWX.png',
          },
          textWrapper: { className: 'content3-text' },
          title: {
            className: 'content3-title',
            children: (
              <span>
                <p>{t('W1545Vl1OnbMxNOTbK4Vc')}</p>
              </span>
            ),
          },
          content: {
            className: 'content3-content',
            children: (
              <span>
                <span>
                  <span>
                    <span>
                      <span>
                        <span>
                          <span>
                            <span>
                              <span>
                                <span>
                                  <p>
                                    {' '}
                                    {t('NicWpOkv1gM1XXBfFXkRX')}
                                  </p>
                                </span>
                              </span>
                            </span>
                          </span>
                        </span>
                      </span>
                    </span>
                  </span>
                </span>
              </span>
            ),
          },
        },
      },
      {
        name: 'block0',
        className: 'content3-block',
        md: 8,
        xs: 24,
        children: {
          icon: {
            className: 'content3-icon',
            children:
              'https://zos.alipayobjects.com/rmsportal/xMSBjgxBhKfyMWX.png',
          },
          textWrapper: { className: 'content3-text' },
          title: {
            className: 'content3-title',
            children: (
              <span>
                <span>
                  <span>
                    <p>{t('dxaJkQgPjtc3bnphDe-zd')}</p>
                  </span>
                </span>
              </span>
            ),
          },
          content: {
            className: 'content3-content',
            children: (
              <span>
                <span>
                  <span>
                    <span>
                      <span>
                        <p>
                          {t('x5lhLNE5tBfKrnLW-crHX')}
                        </p>
                      </span>
                    </span>
                  </span>
                </span>
              </span>
            ),
          },
        },
      },
      {
        name: 'block1',
        className: 'content3-block',
        md: 8,
        xs: 24,
        children: {
          icon: {
            className: 'content3-icon',
            children:
              'https://zos.alipayobjects.com/rmsportal/xMSBjgxBhKfyMWX.png',
          },
          textWrapper: { className: 'content3-text' },
          title: {
            className: 'content3-title',
            children: (
              <span>
                <span>
                  <p>{t('fkMiBhxBq2TnWdAPk747l')}</p>
                </span>
              </span>
            ),
          },
          content: {
            className: 'content3-content',
            children: (
              <span>
                <span>
                  <span>
                    <p>
                      {t('svbGs-KULVbRhHRzb5gQR')}
                    </p>
                  </span>
                </span>
              </span>
            ),
          },
        },
      },
      {
        name: 'block3',
        className: 'content3-block',
        md: 8,
        xs: 24,
        children: {
          icon: {
            className: 'content3-icon',
            children:
              'https://zos.alipayobjects.com/rmsportal/MNdlBNhmDBLuzqp.png',
          },
          textWrapper: { className: 'content3-text' },
          title: {
            className: 'content3-title',
            children: (
              <span>
                <span>
                  <span>
                    <span>
                      <span>
                        <span>
                          <p>{t('OV1aUQrk3z5iEPPvJ5Jto')}</p>
                        </span>
                      </span>
                    </span>
                  </span>
                </span>
              </span>
            ),
          },
          content: {
            className: 'content3-content',
            children: (
              <span>
                <span>
                  <span>
                    <span>
                      <span>
                        <p>
                          {t('TB1fSeN_EdsG8pvRGO05t')}
                        </p>
                      </span>
                    </span>
                  </span>
                </span>
              </span>
            ),
          },
        },
      },
      {
        name: 'block4',
        className: 'content3-block',
        md: 8,
        xs: 24,
        children: {
          icon: {
            className: 'content3-icon',
            children:
              'https://zos.alipayobjects.com/rmsportal/UsUmoBRyLvkIQeO.png',
          },
          textWrapper: { className: 'content3-text' },
          title: {
            className: 'content3-title',
            children: (
              <span>
                <span>
                  <p>{t('dLlMYOdmCyqql4fCN0vXy')}</p>
                </span>
              </span>
            ),
          },
          content: {
            className: 'content3-content',
            children: (
              <span>
                <span>
                  <span>
                    <span>
                      <span>
                        <p>{t('pFsYzpibO6H7ClEdNU7LF')}</p>
                      </span>
                    </span>
                  </span>
                </span>
              </span>
            ),
          },
        },
      },
      {
        name: 'block5',
        className: 'content3-block',
        md: 8,
        xs: 24,
        children: {
          icon: {
            className: 'content3-icon',
            children:
              'https://zos.alipayobjects.com/rmsportal/ipwaQLBLflRfUrg.png',
          },
          textWrapper: { className: 'content3-text' },
          title: {
            className: 'content3-title',
            children: (
              <span>
                <span>
                  <p>{t('uV19qf-I8QI93c_-R0L-r')}</p>
                </span>
              </span>
            ),
          },
          content: {
            className: 'content3-content',
            children: (
              <span>
                <p>{t('MjKIm-IkVlnKkN-AASCO5')}</p>
              </span>
            ),
          },
        },
      },
    ],
  },
});
export const Footer10DataSource = (t) =>({
  wrapper: { className: 'home-page-wrapper footer1-wrapper' },
  OverPack: { className: 'footer1', playScale: 0.2 },
  block: {
    className: 'home-page',
    gutter: 0,
    children: [
      {
        name: 'block0',
        xs: 24,
        md: 6,
        className: 'block',
        title: {
          className: 'logo',
          children:
            'https://www.bmr-oe.com/static/images/logo15.png',
        },
        childWrapper: {
          className: 'slogan',
          children: [
            {
              name: 'content0',
              children: (
                <span>
                  <p>{t('OQ2uPSjdQmJkQsuJnsEof')}</p>
                </span>
              ),
              className: 'm8frbj7scy-editor_css',
            },
          ],
        },
      },
      {
        name: 'block1',
        xs: 24,
        md: 6,
        className: 'block',
        title: { 
          children: (
            <span >
              <p>{t('cBQPp6hgvV3wwA2rza56q')}</p>
            </span>
            ),
          },
        childWrapper: {
          children: [
            {
              name: 'link0',
              href: '/上海铂米瑞产品手册-V1.1.pdf',
              children: (
                <span>
                  <span>
                    <p>{t('8GnyzQTgHryBSN_vRS2WF')}</p>
                  </span>
                </span>
              ),
            },
            {
              name: 'link2',
              href: '/接口定义-V1.0.pdf',
              children: (
                <span>
                  <span>
                    <span>
                      <p>{t('0O_Yb7t0psEHIMAbXWsFl')}</p>
                    </span>
                  </span>
                </span>
              ),
            },
          ],
        },
      },
      {
        name: 'block2',
        xs: 24,
        md: 6,
        className: 'block',
        title: {
          children: (
            <span>
              <p>{t('vrZO3mGcxUmMxF8xFtK03')}</p>
            </span>
          ),
        },
        childWrapper: {
          children: [
            {
              href: '/#/eighth',
              name: 'link0',
              children: (
                <span>
                  <span>
                    <p>{t('HmsN3ezKZFSbzwW6sZPYI')}</p>
                  </span>
                </span>
              ),
            },
            {
              href: '/#/ninth',
              name: 'link1',
              children: (
                <span>
                  <p>{t('ZUf-gq_99SQDbA3HKUPPR')}</p>
                </span>
              ),
            },
          ],
        },
      },
      {
        name: 'block3',
        xs: 24,
        md: 6,
        className: 'block',
        title: {
          children: (
            <span>
              <p>{t('lQHc3C7bauTfK8pglfp23')}</p>
            </span>
          ),
        },
        childWrapper: {
          children: [
            {
              href: '/#/seventh',
              name: 'link0',
              children: (
                <span>
                  <span>
                    <span>
                      <p>{t('c8glr_0G2mlmbwkvO7FwM')}</p>
                    </span>
                  </span>
                </span>
              ),
            },
            {
              href: '/#/sixth',
              name: 'link1',
              children: (
                <span>
                  <span>
                    <span>
                      <p>{t('HQOYW3GBkvNdRE7JSYwvB')}</p>
                    </span>
                  </span>
                </span>
              ),
            },
          ],
        },
      },
    ],
  },
  copyrightWrapper: { className: 'copyright-wrapper' },
  copyrightPage: { className: 'home-page' },
  copyright: {
    className: 'copyright',
    children: (
      <span>
        <span>{t('kXAQHp10lb_zEJ9Rwi_5l')}</span>
      </span>
    ),
  },
});
